<template lang="pug">
v-dialog(
  persistent
  style="z-index: 1000; min-height: 500px!important"
  v-model="showDialog"
  :width="modalWidth")
  v-card
    v-card-title(class="text-h5 grey lighten-2") {{dialogTitle}}

    component(
      class="truncated-folio-detail-height scrollable"
      v-if="!dialogText"
      class="my-2"
      v-bind:is="dialogContent"
      v-bind="currentProperties")
    v-card-text
      div {{dialogText}}

    v-divider(v-if="showModalOptions")

    v-card-actions(v-if="showModalOptions")
      v-spacer
      v-btn(
        color="primary"
        text
        @click="showDialog = false") Cerrar
</template>

<script>
import { mapState } from 'vuex';
import FolioSummary from '@/components/FolioSummary';
import AnnotationSummary from '@/components/annotations/AnnotationSummary';
import PdfPreview from '@/components/PdfPreview';
import ImagePreview from '@/components/ui/ImagePreview';
import AnnotationDetail from '@/components/annotations/AnnotationDetail.vue';
import AnnotationHistogram from '@/components/annotations/AnnotationHistogram.vue';
import AnnotationTimeline from '@/components/annotations/AnnotationTimeline.vue';
import RecordExtraInfo from '@/components/folios/RecordExtraInfo.vue';
import CadastralHelp from '@/components/modalHelpers/CadastralHelp.vue';
import FamilyHelp from '@/components/modalHelpers/FamilyHelp.vue';
import DocumentForm from '@/components/documents/DocumentForm.vue';
import UserForm from '@/components/users/UserForm.vue';

export default {
  name: 'CommonModal',

  components: {
    FolioSummary,
    AnnotationSummary,
    PdfPreview,
    AnnotationDetail,
    AnnotationHistogram,
    AnnotationTimeline,
    RecordExtraInfo,
    ImagePreview,
    CadastralHelp,
    FamilyHelp,
    DocumentForm,
    UserForm,
  },

  data: () => ({
    currentProperties: {},
    // ['FolioSummary', 'AnnotationHistogram', 'RecordExtraInfo'].includes(dialogContent) ? '500' : '100%'"
  }),

  computed: {
    ...mapState('ui', [
      'dialogContent',
      'dialogTitle',
      'dialogText',
      'modalWidth',
      'showModalOptions',
    ]),
    ...mapState('folios', ['viewedAnnotation']),
    showDialog: {
      get() {
        return this.$store.state.ui.showDialog;
      },
      set(value) {
        return this.$store.dispatch('ui/toggleDialog', value);
      }
    }
  },

  watch: {
    '$store.state.ui.dialogContent': {
      deep: true,
      handler(newVal) {
        if (newVal === 'AnnotationDetail') {
          this.currentProperties = {...{annotation:this.viewedAnnotation}};
        }
      }
    },
    '$store.state.folios.viewedAnnotation': {
      deep: true,
      handler() {
        this.currentProperties = {...{annotation:this.viewedAnnotation}};
      }
    }
  },
  
  created() {
    this.$bus.$on('update-properties', (data) => {
      this.currentProperties = data;
    });
  },
  
  mounted() {
    if (this.dialogContent === 'AnnotationDetail') {
      this.currentProperties.annotation = this.viewedAnnotation;
    }
  },
}
</script>
